import React from 'react'
import { Link, useNavigate } from 'react-router-dom';
import DropDownDevider from './DropDownDevider';
const baseURL = process.env.REACT_APP_BASE_URL;

export default function PillBtn({
    isSubmitBtn = false,
    isDisabled = false,
    routeName = "",
    imgURL = "",
    text = "",
    isWithClass = false,
    classes = '',
    isExternal = false,
    isNoAction = false,
    isRed = false,
    isFirstPill = false,
    isLastPill = false,
    isNoPadding = false,
    isNoMargin = false,
    isDropDown = false,
    handlelogout,
    translate,
    isOutLine = false,
    ...props
}) {
    const ButtonStyle = {
        fontSize: 13,
        width: 'unset',
        paddingLeft: isNoPadding ? 'unset' : !!imgURL ? 28 : 34,
        paddingRight: isNoPadding ? 'unset' : !!imgURL ? 28 : 34,
        height: 32,
    };

    const navigate = useNavigate();

    if (!!isSubmitBtn) {
        return (
            <button {...props} type='submit' style={ButtonStyle} className={`${isFirstPill ? 'ms-auto' : ''} w-100 ${isNoMargin ? '' : 'mx-1'}  my-auto ${isLastPill ? 'me-0' : ''} ${classes}  d-flex align-items-center fw-bold  ${isRed ? '' : isWithClass ? `${classes}` : 'bg-offWhite black-color-new'}  btn ${isWithClass ? '' : 'btn-danger'}  ${isDisabled ? 'disabled' : ''}  rounded-pill justify-content-center `}>
                {!!imgURL &&
                    <img
                        className="me-2"
                        style={{
                            width: 20,
                        }}
                        src={baseURL + imgURL} />
                }
                {text}
            </button>
        )
    } else if (isDropDown) {
        return (
            <div {...props} style={ButtonStyle} id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" className={`${isFirstPill ? 'ms-auto' : ''} ${classes} my-auto ${isLastPill ? 'me-0' : ''} ${isNoMargin ? '' : 'mx-1'} d-flex align-items-center fw-bold border-0 ${isRed ? '' : 'bg-offWhite black-color-new'} dropdown  btn btn-danger ${isDisabled ? 'disabled' : ''}  rounded-pill justify-content-center`}>
                {text}
                <ul className="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                    <li><Link onClick={() => {
                        navigate('/profile')
                    }} to={'/profile'} className="dropdown-item" > {translate('web.accountSettings', 'Account Setting')}
                    </Link>
                        <DropDownDevider />
                    </li>
                    <li><button onClick={handlelogout} className="dropdown-item" > {translate('web.logout', 'Logout')}
                    </button></li>
                </ul>
            </div>
        )

    } else if (!isOutLine) {
        return (
            <Link {...props} to={routeName} onClick={isNoAction ? (e) => { e.preventDefault() } : () => { }} style={ButtonStyle} target={isExternal ? '_blank' : '_self'} className={`${isFirstPill ? 'ms-auto' : ''} ${classes} my-auto ${isLastPill ? 'me-0' : ''} ${isNoMargin ? '' : 'mx-1'} d-flex align-items-center fw-bold border-0 ${isRed ? '' : 'bg-offWhite black-color-new'}  btn btn-danger ${isDisabled ? 'disabled' : ''}  rounded-pill justify-content-center`}>
                {!!imgURL &&
                    <img
                        className="me-2"
                        style={{
                            width: 20,
                        }}
                        src={baseURL + imgURL} />
                }
                {text}
            </Link>
        )
    } else {
        return (
            <Link {...props} to={routeName} onClick={isNoAction ? (e) => { e.preventDefault() } : () => { }} style={ButtonStyle} target={isExternal ? '_blank' : '_self'} className={`${classes} my-auto d-flex align-items-center fw-bold  ${isDisabled ? 'disabled' : ''}  rounded-pill justify-content-center`}>
                {!!imgURL &&
                    <img
                        className="me-2"
                        style={{
                            width: 20,
                        }}
                        src={baseURL + imgURL} />
                }
                {text}
            </Link>)
    }
}
